<template>
  <v-container>
    <v-row justify="center">
      <v-col md="8" xs="12">
        <v-card :flat="!$vuetify.breakpoint.smAndUp">
          <v-card-title :class="!$vuetify.breakpoint.smAndUp ? 'pa-0' : ''">
            Form Sent!
          </v-card-title>
          <v-card-text>
            Your production manager will receive your filled out paperwork via
            email.
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <!-- <v-row justify="center">
      <v-col md="8" xs="12">
        <v-card :flat="!$vuetify.breakpoint.smAndUp">
          <v-card-title :class="!$vuetify.breakpoint.smAndUp ? 'pa-0' : ''">
            Would you like to refer a production manager?
          </v-card-title>

          <v-card-text>
            Let us know if there are any other production managers out there
            that should hear about FPS. We will send them an email explaining
            what we do and how we can help them.
          </v-card-text>
          <v-col cols="12">
            <v-text-field
              v-model="email"
              label="Production Manager Email You Want to Refer"
              :rules="[rules.email]"
              data-cy="referral-form-email"
            />
          </v-col>
          <v-col cols="12">
            <v-btn
              color="primary"
              data-cy="referall-form-btn-send"
              @click="submit"
            >
              Send
            </v-btn>
          </v-col>
        </v-card>
      </v-col>
    </v-row> -->
  </v-container>
</template>

<script>
import rules from "../utils/rules";
import { emailManager } from "../services/referrals";

export default {
  data() {
    return {
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
        numeric: (value) => {
          if (!value) return true;
          if (/[a-zA-Z ]/.test(value)) return "Not a valid number.";
          return !Number.isNaN(parseFloat(value)) || "Not a valid number.";
        },
      },
      email: "",
      freelancerEmail: "",
      employeeFirstName: "",
      employeeLastName: "",
      job: "",
    };
  },

  async mounted() {
    this.employeeFirstName = this.$route.params.firstName;
    this.employeeLastName = this.$route.params.lastName;
    this.job = this.$route.params.job;
    this.freelancerEmail = this.$route.params.freelancerEmail;
    console.log(this.$route.params);
  },

  methods: {
    async submit() {
      if (this.email === "") {
        this.$emit("snackbar", {
          text: "Please enter an email to send a referral to that person.",
          color: "red",
        });
        return;
      } else if (this.freelancerEmail === this.email){
        this.$emit("snackbar", {
          text: "Please enter an email to send a referral not your own email.",
          color: "red",
        });
        return;
      }
      let payload = {
        productionManagerEmail: this.email,
        employeeFirstName: this.employeeFirstName,
        employeeLastName: this.employeeLastName,
        job: this.job,
      };
      try {
        await emailManager(payload);
        this.$router.push({
          name: "referral-success",
          params: {
            email: this.email,
            employeeFirstName: this.employeeFirstName,
            employeeLastName: this.employeeLastName,
          },
        });
      } catch (e) {
        if (e.response.status === 502) {
          this.$emit("snackbar", { text: "502 Bad Gateway", color: "red" });
        } else {
          this.$emit("snackbar", {
            text: "Error Sending Email",
            color: "red",
          });
        }
      }
    },
  },
};
</script>